<template>
  <div class="ctn">
    <div>{{ updateStatus }}</div>
    <div v-show="updateDownloadPercentage" class="download-progress-ctn">
      <el-progress :percentage="updateDownloadPercentage" :status="updateDownloadStatus" class="download-progress" />
    </div>
  </div>
</template>

<script>
export default {
  name: "updater",
  data() {
    return {
      checkingUpdate: false,
      checkUpdateResult: undefined,
      updateStatus: undefined,
      updateDownloadPercentage: undefined,
      updateDownloaded: false,
      updateDownloadedInfo: undefined,
    }
  },
  computed: {
    updateDownloadStatus: function() {
      return this.updateDownloadPercentage === 100 ? "success" : undefined
    }
  },
  watch: {
    checkingUpdate: function() {
      this.$emit('isCheckingChanged', this.checkingUpdate)
    },
    checkUpdateResult: function() {
      this.$emit('checkUpdateResultChanged', this.checkingUpdate)
    },
    updateStatus: function() {
      this.$emit('updateStatusChanged', this.updateStatus)
    },
    updateDownloadPercentage: function() {
      this.$emit('updateDownloadPercentageChanged', this.updateDownloadPercentage)
    },
    updateDownloaded: function() {
      this.$emit('updateDownloaded', this.updateDownloadedInfo)
    },
  },
  mounted() {
    this.utils.update.addHandlerForCheckUpdate(this.checkingUpdateHandler)
    this.utils.update.addHandlerForCheckUpdateErr(this.checkingUpdateErrhandler)
    this.utils.update.addHandlerForUpdateAvailable(this.updateAvailableHandler)
    this.utils.update.addHandlerForUpdateNotAvailable(this.updateNotAvailableHandler)
    this.utils.update.addHandlerForUpdateDownloadProgress(this.updateDownloadProgressHandler)
    this.utils.update.addHandlerForUpdateDownloaded(this.updateDownloadedHandler)
  },
  methods: {
    check() {
      this.checkingUpdate = true
      let self = this
      this.utils.update.checkUpdate((checkResult) => {
        self.checkingUpdate = false
        console.log("checkResult:", checkResult)
        if (checkResult === "Not support this running env") {
          return
        }
        self.checkUpdateResult = checkResult
      })
    },
    checkingUpdateHandler() {
      console.log("checkingUpdateHandler")
      this.updateStatus = "正在检查更新..."
    },
    checkingUpdateErrhandler(event, err) {
      console.debug("checkingUpdateErrhandler: event: ", event)
      console.log("checkingUpdateErrhandler: err: ", err)
      this.updateStatus = "检查更新失败"
      this.checkingUpdate = false

      // this.$notify.error({
      //   title: "检查更新失败",
      //   message: err,
      //   duration: 0
      // })

      this.$emit("checkingUpdateFailed", err)
    },
    updateAvailableHandler(event, info) {
      this.checkingUpdate = false
      console.debug("updateAvailableHandler: event: ", event)
      console.log("updateAvailableHandler: info: ", info)
      this.updateStatus = `发现新版本: ${info.version} ${info.releaseDate ? "(" + info.releaseDate + ")" : ""}, 开始下载....`
    },
    updateNotAvailableHandler(event, info) {
      this.checkingUpdate = false
      console.debug("updateNotAvailableHandlerL event: ", event)
      console.log("updateNotAvailableHandlerL info: ", info)
      this.updateStatus = "当前已是最新版本"

      // this.$notify.success({
      //   title: "当前已经是最新版本",
      //   duration: 0
      // })

      this.$emit("updateNotAvailable", info)
    },
    // progress.total Bytes Number 总字节数
    // progress.delta Bytes Number 距离上次本时间触发后下载的字节数
    // progress.transferred Number 已传输字节数
    // progress.percent Number 以传输百分比(有小数点, e.g: 89.54332120097385)
    // progress.bytesPerSecond Bytes Number
    updateDownloadProgressHandler(event, progress) {
      this.checkingUpdate = false
      console.debug("updateDownloadProgressHandler: event: ", event)
      console.log("updateDownloadProgressHandler: progress: ", progress)
      this.updateDownloadPercentage = progress.percent.toFixed(2)
      console.debug("human size")
      console.debug("this.utils.human.size(progress.transferred):", this.utils.human.size(progress.transferred))
      console.debug("this.utils.human.size(progress.total):", this.utils.human.size(progress.total))
      console.debug("this.utils.human.size(progress.bytesPerSecond):", this.utils.human.size(progress.bytesPerSecond))
      this.updateStatus = `下载更新: ${this.utils.human.size(progress.transferred)}/${this.utils.human.size(progress.total)}(${this.utils.human.size(progress.bytesPerSecond)}/s)`
      if (progress.transferred === progress.total) {
        this.updateStatus = "更新包下载完成! 退出服务时将会自动安装!"
        this.updateDownloadPercentage = undefined
      }
    },
    updateDownloadedHandler(info) {
      // console.log("updateDownloadedHandler: info", info)
      this.updateDownloadedInfo = info
      this.updateDownloaded = true
      this.updateStatus = `新版本已就绪! 退出服务时将会自动安装!`
      this.env.ui.showUpdateDownloaded(info)
    },
  },
}
</script>

<style scoped>
.ctn {
  font-size: 14px;
  display: flex;
  align-items: center;
}
.download-progress-ctn {
  width: 200px;
  margin-left: 1.2em;
}
.download-progress {
  display: flex;
  align-items: center;
}
</style>